



























import { computed, defineComponent } from '@vue/composition-api';

const name = 'ttam-ad-name';
export default defineComponent({
  name,
  props: {
    tagVisible: {
      type: Boolean,
      default: false,
    },
    tagClosable: {
      type: Boolean,
      default: false,
    },
    tagContent: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const _creativeName = computed({
      get: () => props.value,
      set: (val: string) => {
        emit('change', val);
        emit('input', val);
      },
    });
    const onCloseTag = () => {
      emit('close-tag');
    };
    return {
      name,
      _creativeName,
      onCloseTag,
    };
  },
});
